export const OuterContainer = {
  width: 2560,
  height: 1600,
};

export const WindowArea = {
  width: 550,
  height: 1050,
};

export const AlertArea = {
  width: 550,
  height: 180,
};

export const TACSITArea = {
  width: 1570,
  height: 1363,
};

export const PrimaryCloseControlArea = {
  width: 220,
  height: 700,
};

export const RoleArea = {
  width: 440,
  height: 613,
};

export const TabPanelArea = {
  width: 2010,
  height: 180,
};

export const NotificationArea = {
  width: 2560,
  height: 28,
};

export const MenuBarArea = {
  width: 2120,
  height: 29,
};

export const HookTrackArea = {
  width: 440,
  height: 29,
};

export const WindowHeaderHeight = 15;

export const GfcsMapArea = {
  width: 1005,
  height: 1600,
};

export const AlphaRVideoArea = {
  width: 550,
  height: 280,
};
